import type { BrowserZipState } from "features/browserZipSlice";

export const BROWSER_ZIP_STORAGE_KEY = "calibrate_browser_zip_v1";

type PersistedV1 = {
  v: 1;
  userId: number;
  jobs: BrowserZipState["jobs"];
};

export function persistBrowserZipState(
  userId: number | undefined,
  jobs: BrowserZipState["jobs"],
): void {
  if (userId == null) return;
  try {
    const payload: PersistedV1 = {
      v: 1,
      userId: Number(userId),
      jobs,
    };
    localStorage.setItem(BROWSER_ZIP_STORAGE_KEY, JSON.stringify(payload));
  } catch {
  }
}

export function loadBrowserZipState(): Omit<PersistedV1, "v"> | null {
  try {
    const raw = localStorage.getItem(BROWSER_ZIP_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedV1;
    if (parsed?.v !== 1 || parsed.userId == null) return null;
    return {
      userId: Number(parsed.userId),
      jobs: parsed.jobs ?? {},
    };
  } catch {
    return null;
  }
}

export function clearBrowserZipStorage(): void {
  try {
    localStorage.removeItem(BROWSER_ZIP_STORAGE_KEY);
  } catch {
  }
}
